// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyD9oWPRnfK26JE7nyUZr74fBDBr4Yx7QZI",
    authDomain: "affirmation-app-5fc8b.firebaseapp.com",
    projectId: "affirmation-app-5fc8b",
    storageBucket: "affirmation-app-5fc8b.appspot.com",
    messagingSenderId: "301196591168",
    appId: "1:301196591168:web:bf91e8b50275f0bb60dfa5"
};

// Initialize Firebase
const firebase = initializeApp(firebaseConfig);

export default firebase;